export default __webpack_public_path__ + "static/media/caroline_logo.e3318bbb.svg";